import styled from "styled-components";
import { DetailsSection } from "../MainSection.styles";

export const ErrorContainer = styled.div`

@media screen and (max-width:768px) {
  ${DetailsSection} & {
    position: absolute;
    height: 100%;
    background: #fff;
    width: 100%;
   }
}`;

export const ImageIcon = styled.img`

@media screen and (max-width:480px) {
  width: 80px;
  height: 80px;
}
`;